/*
 * @Author: wang.haiyan
 * @Date: 2021-11-25 16:25:44
 * @Last Modified by: zhang.si
 * @Last Modified time: 2022-03-25 16:08:09
 */
/* eslint-disable react/no-danger */

import React, { useEffect, useState } from 'react';
import { history, connect } from 'umi';

import DOMPurify from 'dompurify';
import useGCPI18n from '@/hooks/useGCPI18n';
import { sanitizeParam } from '@/utils/sanitize';

import { trackSensors } from '@/utils/sensors';

import Header from '@/components/Header';
import style from './index.less';

const Rules = props => {
  const { dispatch, gameCode } = props;
  const GCPI18n = useGCPI18n();
  const [rules, setRules] = useState();
  const serviceUrl = localStorage.getItem('serverUrl');
  const GameI18n = JSON.parse(window.localStorage.getItem('GAME_i18n'));
  const rawQuery = history?.location?.query || {};
  const pageHeader = sanitizeParam(rawQuery.pageHeader, /^[a-zA-Z0-9\s._-]*$/);
  const hideGoHome = !!rawQuery.hideGoHome;
  const rawState = history?.location?.state || {};
  const pageHeaderNew = sanitizeParam(rawState.pageHeaderNew, /^[a-zA-Z0-9\s._-]*$/);
  const hideGoHomeNew = !!rawState.hideGoHomeNew;
  const isRulesShow = rawState.isRulesShow !== false;
  const fontFamily = sanitizeParam(rawState.fontFamily, /^[a-zA-Z0-9\s.'"_-]*$/);

  useEffect(() => {
    trackSensors('ViewMechanics');
    const type = 'index/getLuckyDrawRuleDXP';
    dispatch({
      type,
      payload: gameCode,
    }).then(res => {
      const comments = res.replaceAll('src="', `src="${serviceUrl}`);
      setRules(comments);
    });
  }, []);

  return (
    <div className={style.page}>
      <div className={style.container}>
        <Header
          title={pageHeaderNew || pageHeader || GCPI18n({ id: 'lb_main_rules' })}
          titleColor="#3E3E3E"
          titleFontFamily={fontFamily}
          hideGoHome={hideGoHome || hideGoHomeNew}
          onlyGoBack
        />
        {/* <Header title={GCPI18n({ id: 'lb_main_mechanics' })} /> */}
        {isRulesShow && <h2>{GCPI18n({ id: 'lb_main_rules' })}</h2>}
        <div
          // className={style.rules}
          className={`${style.rules} wangEditorStyle`}
          style={{ fontFamily }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(GameI18n?.comments || rules || ''),
          }}
        />
      </div>
    </div>
  );
};

export default connect(({ index }) => ({
  activityDetail: index.activityDetail,
  gameCode: index.gameCode,
}))(Rules);
